import React from 'react';
import { Typography } from 'antd';
import { WorkerUploadReviewErrors } from './worker-upload-review-errors';
import { ContentContainer, Icon } from '@common/components';
import { CSVError } from 'works/legacy/lib/csv-error';
import { WorkerUploadReviewTable } from './worker-upload-review-table';
import { ImportWorker } from '@scheduling/graphql/mutations/workers-import';

const { Text } = Typography;

type Props = {
  importWorkers: ImportWorker[];
  errors: CSVError[];
};

export function WorkerUploadReview({ importWorkers, errors }: Props) {
  const workerCount = importWorkers.length;
  const relativeText =
    workerCount > 1 ? 'staff members are' : 'staff member is';

  return (
    <>
      {!errors.length ? (
        <ContentContainer
          title="Review Import"
          header={
            <Text>
              {workerCount} {relativeText} ready to be imported.
            </Text>
          }
        >
          <WorkerUploadReviewTable importWorkers={importWorkers} />
        </ContentContainer>
      ) : (
        <ContentContainer
          title={
            <>
              <Icon icon="ban" kind="regular" color="coral" size="xl" />
              This file can&apos;t be uploaded
            </>
          }
          header={
            <Text>
              Correct the errors below and go back to upload the updated file
              when ready.
            </Text>
          }
        >
          <WorkerUploadReviewErrors errors={errors} />
        </ContentContainer>
      )}
    </>
  );
}
